document.addEventListener("DOMContentLoaded", function () {
    const t = document.getElementById("button-back"),
        n = document.getElementById("button-span");
    if (!t) return;
    const e = document.getElementById("site").value,
        o = document.referrer;
    let d = "";
    if (o)
        try {
            d = new URL(o).origin + "/";
        } catch {}
    o && (o.startsWith(e) || d === e)
        ? ((n.textContent = "BACK"),
          t.addEventListener("click", function (c) {
              c.preventDefault(), window.history.back();
          }))
        : ((n.textContent = "HOME"),
          t.addEventListener("click", function (c) {
              c.preventDefault(), (window.location.href = e);
          }));
}),
    document.addEventListener("DOMContentLoaded", function () {
        const t = document.getElementById("button-home");
        if (!t) return;
        const n = document.getElementById("site").value;
        t.addEventListener("click", function (e) {
            e.preventDefault(), (window.location.href = n);
        });
    });
//# sourceMappingURL=backbutton.js.map
